function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { mapState, mapMutations } from 'vuex';
import UserSecurityService from '@/apps/data-platform/services/security/user_security_service';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { PATTERNS_VALIDATION } from '@/js/constants';
import AttributeService from '@/apps/attributes/services/attributes_service';
export var useCaseMixin = {
  data: function data() {
    return {
      useCase: {},
      emailPattern: PATTERNS_VALIDATION.EMAIL_GENERAL,
      errors: [],
      isLoadingEmail: false,
      INTERBANK_DOMAIN: 'interbank.pe',
      service_account: null,
      businessAreas: [],
      ATTRIBUTE_USER: 'attribute_user'
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    getUseCase: function getUseCase() {
      var _this = this;
      var company = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.setShowLoading(false);
      var companyCode = company || this.companyCode;
      return UseCasesService.getUseCaseById(companyCode, this.item.id).then(function (response) {
        var data = response.data;
        var metadataFields = data.metadata[0];
        var attributes = data.attributes;
        _this.useCase = _objectSpread(_objectSpread(_objectSpread({}, _this.item), metadataFields), {}, {
          attributes: attributes
        });
        _this.setShowLoading(false);
      });
    },
    getBusinessAreas: function getBusinessAreas() {
      var _this2 = this;
      if (this.companyCode !== this.useCase.company_code) {
        AttributeService.getBusinessUserServiceAccounts(this.useCase.company_code).then(function (response) {
          _this2.businessAreas = response.data && response.data.business_users ? Object.values(response.data.business_users) : [];
        });
      } else {
        this.businessAreas = this.businessUserServiceAccounts;
      }
    },
    isUserOwner: function isUserOwner(user) {
      return this.useCase.owner_name === user;
    },
    ruleEmailMultiSelect: function ruleEmailMultiSelect(value) {
      if (value.length === 0) {
        return this.translate('reglas.field');
      } else if (value.length > 0) {
        var last_input = value[value.length - 1];
        var regexValidation = this.emailPattern.test(last_input);
        if (!regexValidation) {
          return this.translate('reglas.wrong_emails');
        }
        if (this.users.indexOf(last_input) !== -1) {
          return this.translate('reglas.duplicate_email');
        }
        return true;
      } else {
        return true;
      }
    },
    validateDomainEmail: function validateDomainEmail(email) {
      var _this3 = this;
      this.isLoadingEmail = true;
      var params = {
        email: email
      };
      return UserSecurityService.getDomainUser(params).then(function (response) {
        var domain = response.data.domain;
        if (_this3.orgs.findIndex(function (item) {
          return item.domain === domain;
        }) === -1) {
          _this3.errors = [_this3.translate('reglas.invalid_email')];
          return;
        }
        if (_this3.useCase.organization) {
          // Se trata de editar usuarios en el caso de uso
          // Se valida el dominio con el dominio del caso de uso
          if (domain !== _this3.useCase.organization) {
            _this3.errors = [_this3.translate('reglas.attributes_wrong_domain')];
            return;
          }
        } else {
          // Se trata de un nuevo caso de uso
          if (domain !== _this3.userDomain) {
            _this3.errors = [_this3.translate('reglas.attributes_wrong_domain')];
            return;
          }
        }
      }).finally(function () {
        _this3.isLoadingEmail = false;
      });
    },
    verifyEmailRol: function verifyEmailRol(email) {
      var _this4 = this;
      this.isLoadingEmail = true;
      var params = {
        email: email,
        rol: this.ATTRIBUTE_USER
      };
      return UserSecurityService.postVerifyEmailRol(params).then(function (response) {
        console.log('response.data--');
        console.log(response.data);
        if (response.data.result === false) {
          _this4.errors = [_this4.translate('reglas.email_no_inca')];
          return;
        }
      }).finally(function () {
        _this4.isLoadingEmail = false;
      });
    },
    getAttributeSource: function getAttributeSource(attributeSourceId) {
      return this.attributeSourcesCatalog[attributeSourceId.toString()];
    },
    onSelectServiceAccount: function onSelectServiceAccount(serviceAccountEmail) {
      this.newUsers.push(serviceAccountEmail.trim());
    },
    isIbkDomain: function isIbkDomain() {
      return this.userDomain === this.INTERBANK_DOMAIN;
    }
  }),
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'orgs', 'companyName'])), mapState('attribute', ['attributeSourcesCatalog', 'businessUserServiceAccounts'])), {}, {
    expirationDate: function expirationDate() {
      return this.$moment(new Date(this.useCase.access_deadline_date)).format('DD-MM-YYYY');
    },
    users: function users() {
      var users = [];
      if (this.useCase.env_user_group) {
        var usersMetadata = this.useCase.env_user_group.email || [];
        users = Object.values(usersMetadata);
      }
      return users;
    },
    getBusinessArea: function getBusinessArea() {
      var _this5 = this;
      var businessArea = {};
      if (this.useCase.env_user_group) {
        Object.values(this.useCase.env_user_group.email).forEach(function (item) {
          businessArea = _this5.businessAreas.find(function (element) {
            return element.email === item;
          });
        });
      }
      return businessArea;
    }
  }),
  watch: {
    newUsers: function newUsers(newValue, oldValue) {
      if (newValue.length > 0) {
        this.errors = [];
        var last_input = newValue[newValue.length - 1];
        var isServiceAccount = last_input.includes('iam.gserviceaccount');
        if (this.isIbkDomain() && isServiceAccount) {
          return;
        } else {
          this.verifyEmailRol(last_input);
        }
      }
    },
    service_account: function service_account(newValue, oldValue) {
      if (newValue !== oldValue) {
        var index = this.newUsers.findIndex(function (email) {
          return email === oldValue;
        });
        if (index !== -1) {
          this.newUsers.splice(index, 1);
        }
      }
    }
  }
};